import { render, staticRenderFns } from "./zlButton.vue?vue&type=template&id=48292b7f&scoped=true&"
import script from "./zlButton.vue?vue&type=script&lang=js&"
export * from "./zlButton.vue?vue&type=script&lang=js&"
import style0 from "./zlButton.vue?vue&type=style&index=0&id=48292b7f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48292b7f",
  null
  
)

export default component.exports